import UserApiBase from "../base/UserApiBase";

import { type OkResponse } from "@/schemas/api/ok";
import { type AppUserSession } from "@/schemas/auth/session";
import {
  type DeleteAccountRequest,
  type SetOnboardingStageRequest,
  type UserIdentity,
  UserIdentitySchema,
} from "@/schemas/user/identity";

class IdentityService extends UserApiBase {
  public constructor(session: AppUserSession) {
    super("/identity", session);
  }

  public async getUserIdentity(): Promise<UserIdentity> {
    const response = await this.get<UserIdentity>("/");
    const validatedResponse = UserIdentitySchema.parse(response);

    return validatedResponse;
  }

  public async refreshUserIdentity(): Promise<UserIdentity> {
    const response = await this.get<UserIdentity>("/refresh");
    const validatedResponse = UserIdentitySchema.parse(response);

    return validatedResponse;
  }

  public async getOrCreateUserIdentity(): Promise<UserIdentity> {
    const response = await this.post<UserIdentity>("/user_identity", {});
    const validatedResponse = UserIdentitySchema.parse(response);

    return validatedResponse;
  }

  public registerPushToken(expoToken: string): Promise<OkResponse> {
    return this.post<OkResponse>("/register_push_token", {
      token: expoToken,
    });
  }

  public deleteAccount(body: DeleteAccountRequest): Promise<OkResponse> {
    return this.post<OkResponse>("/delete_account", { ...body });
  }

  public setOnboardingStage(
    body: SetOnboardingStageRequest,
  ): Promise<OkResponse> {
    return this.post<OkResponse>("/set_onboarding_stage", { ...body });
  }
}

export default IdentityService;
